import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ChipTimeChipPickerLabels } from '@sb/library/base';
import { SBTime } from '@sb/library/localization';
import { ChipTimeRangePickerPanelComponent } from '../panel/chip-time-range-picker-panel.component';

@Component({
    selector: 'lib-chip-time-range-bottom-sheet-panel',
    templateUrl: '../panel/chip-time-range-picker-panel.component.html',
})
export class ChipTimeRangePickerBottomSheetComponent extends ChipTimeRangePickerPanelComponent {

    constructor(private _MatBottomSheetRef: MatBottomSheetRef<ChipTimeRangePickerBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: {CurrentTimeRange: (SBTime | null)[], Labels: ChipTimeChipPickerLabels}) {
        super();

        this._MatBottomSheetRef.afterOpened().subscribe(_ => {
            this.UpdateStartEndTime(data.CurrentTimeRange[0], data.CurrentTimeRange[1]);
        });

        this._MatBottomSheetRef.backdropClick().subscribe(_ => {
            this._MatBottomSheetRef.dismiss({CurrentTimeRange: [this.startSBTime, this.endSBTime]});
        });
    }

    override ApplyClicked(): void {
        this._MatBottomSheetRef.dismiss({CurrentTimeRange: [this.startSBTime, this.endSBTime]});
    }

    override get labels(): ChipTimeChipPickerLabels {
        return this.data.Labels;
    }
}
